export const zoop = {
  DEV_ZOOP_MARKETPLACE_ID: "ed2890b3074c458d9e958cc8ad4c51c5",
  DEV_ZOOP_TOKEN: "enBrX3Rlc3RfZnVNbzFpbHprTkRXSFgzc2VCbWROUnp4Og==",
  ZOOP_MARKETPLACE_ID: "79c2a5744b334606bf5e37019083db9b",
  ZOOP_TOKEN: "enBrX3Byb2Rfc21aU1poU2ZxN0xLT2ZkdEtIRGNwZGFGOg==",
  DEV_ZOOP_CREDIT_CARD_NUMBER: "4539003370725497",
  DEV_ZOOP_CREDIT_CARD_HOLDER_NAME: "ZOOP",
  DEV_ZOOP_CREDIT_CARD_CODE: "123",
  DEV_ZOOP_CREDIT_CARD_EXP_YEAR: "20",
  DEV_ZOOP_CREDIT_CARD_EXP_MONTH: "01",
};
